import styled from "styled-components"
import { breakpoints } from "@theguarantors/ui-kit-v2/dist/design-system/breakpoints"
import footerSvg from "../../../assets/footer.svg"
import { theme } from "@theguarantors/ui-kit-v2/dist/design-system"

export const Container = styled.div`
  max-width: 124rem;
  margin: 0 auto;
`

export const First = styled.div`
  @media (min-width: ${breakpoints[2]}) {
    display: flex;
    justify-content: flex-start;

    nav {
      margin-left: 3.2rem;
      display: flex;
      justify-content: space-between;
      flex: 1;
    }
  }
`
export const Second = styled.div`
  @media (min-width: ${breakpoints[2]}) {
    display: flex;
    justify-content: space-between;
  }
`

export const FooterContainer = styled.footer`
  background-color: ${theme.colors.violet};
  color: white;
  padding: 5rem 2rem;

  @media (min-width: ${breakpoints[2]}) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background-color: transparent;
    background-image: url(${footerSvg});
    background-repeat: no-repeat;
    background-size: 100vw;
    height: 59vw;
    padding-bottom: 1rem;
  }
`

// __________________ newGetStartedPageFeatureFlag

export const FooterSection = styled.div`
  padding-top: 4rem;
  background: #080a2d;

  ul,
  li {
    list-style-type: none;
  }
`

export const FooterTop = styled.div`
  padding: 3rem 6rem;
  color: white;
  background: #080a2d;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.5);

  @media (min-width: ${breakpoints[2]}) {
  }
`
export const Logo = styled.div`
  width: 100%;
  margin-bottom: 4rem;

  @media (min-width: ${breakpoints[2]}) {
    margin-bottom: 0;
    img {
      height: 90px;
      width: 700px;
    }
  }
`
export const Content = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 4rem;

  @media (min-width: ${breakpoints[2]}) {
    flex-direction: row;
  }
`
export const LinkColumns = styled.div`
  nav {
    display: flex;
    justify-content: flex-start;
    margin: 3rem 0;
    @media (min-width: ${breakpoints[2]}) {
      margin: 0;
    }

    & > *:first-child {
      margin-right: 12rem;
    }
    & > * {
      margin-right: 6rem;
    }
  }
`
interface SocialMediaProps {
  mobile?: boolean
}
export const SocialMedia = styled.div<SocialMediaProps>`
  margin-top: 2.2rem;
  a {
    margin-right: 1.6rem;
  }
  display: ${(props: CopyrightProps) => (props.mobile ? "flex" : "none")};

  @media (min-width: ${breakpoints[2]}) {
    display: ${(props: CopyrightProps) => (props.mobile ? "none" : "flex")};
    direction: row;
    justify-content: flex-end;
  }
`

export const FooterBottom = styled.div`
  padding: 3rem 6rem;
  color: white;
  background: #080a2d;
  font-size: 1.6rem;
  font-family: ${theme.fonts.acid};
  font-weight: 400;
`

export const Subtitle = styled.div`
  width: 100%;
  margin-top: 1rem;
  opacity: 0.5;

  @media (min-width: ${breakpoints[2]}) {
    width: 50%;
  }
`
export const LinkRow = styled.div`
  width: 100%;
  opacity: 0.5;
  margin-top: 2.4rem;
  display: flex;
  justify-content: space-between;
`

interface CopyrightProps {
  mobile?: boolean
}
export const Copyright = styled.div<CopyrightProps>`
  width: 100%;
  display: ${(props: CopyrightProps) => (props.mobile ? "block" : "none")};
  padding-bottom: 1.6rem;

  @media (min-width: ${breakpoints[2]}) {
    width: ${(props: CopyrightProps) => (props.mobile ? "100%" : "25%")};
    display: ${(props: CopyrightProps) => (props.mobile ? "none" : "block")};
  }
`
export const Links = styled.div`
  spacing: 1.6rem;
  justify-content: flex-end;
  width: 100%;

  display: grid;
  grid-template: auto auto / 1fr 1fr;

  @media (min-width: ${breakpoints[2]}) {
    display: flex;
    width: 55%;
    min-width: 750px;
  }
`
interface LinkItemProps {
  smallScreenWidth?: string
  desktopWidth?: string
}
export const LinkItem = styled.div<LinkItemProps>`
  margin-bottom: 1.6rem;
  width: ${(props: LinkItemProps) => props.smallScreenWidth || "100%"};

  @media (min-width: ${breakpoints[2]}) {
    width: ${(props: LinkItemProps) => props.desktopWidth || "100%"};
  }
`
